import { WebTrackerManagerColumn } from "./WebTrackerManagerPage/sort";

export type WebTrackerOverviewColumnName =
  | "Tracking Tool"
  | "Pages Detected"
  | "Resolution"
  | "Action Items"
  | "Risk"
  | "First Detected"
  | "Last Detected";

export default function useWebTrackerOverviewColumns(): WebTrackerManagerColumn[] {
  return [
    {
      name: "Tracking Tool",
      tooltip: "Name or URL of the tracker seen on your site",
      isSortable: true,
      tableCellStyles: { minWidth: "18em" },
    },
    {
      name: "Pages Detected",
      tooltip: "Approximate number of pages where the tracker was detected",
      isSortable: true,
      align: "left",
      tableCellStyles: { minWidth: "6em" },
      labelStyles: { minWidth: "6em" },
    },
    {
      name: "Resolution",
      tooltip: "How the tracker's impact on HIPAA compliance was addressed",
      align: "left",
      isSortable: false,
      tableCellStyles: { minWidth: "8em" },
      labelStyles: { minWidth: "8em" },
    },
    {
      name: "Action Items",
      tooltip: "Recommended action items to resolve the tracker",
      align: "left",
      isSortable: false,
      tableCellStyles: {
        minWidth: "12em",
        textAlign: "left",
      },
      labelStyles: { minWidth: "12em", textAlign: "left" },
    },
    {
      name: "Risk",
      tooltip: "Risk level of the tracker",
      isSortable: true,
      align: "center",
      tableCellStyles: { textAlign: "center" },
    },
    {
      name: "First Detected",
      tooltip: "Date when the tracker was first detected",
      isSortable: true,
      tableCellStyles: { minWidth: "5em" },
      labelStyles: { minWidth: "5em" },
    },
    {
      name: "Last Detected",
      tooltip: "Date when the tracker was last detected",
      isSortable: true,
      tableCellStyles: { minWidth: "5em" },
      labelStyles: { minWidth: "5em" },
    },
  ];
}
